export default "__VITE_ASSET__BZWtiKAt__"